import { render, staticRenderFns } from "./ResearchOutputWorkArea.vue?vue&type=template&id=02c06085&scoped=true&"
import script from "./ResearchOutputWorkArea.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputWorkArea.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputWorkArea.vue?vue&type=style&index=0&id=02c06085&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c06085",
  null
  
)

export default component.exports